//やるべきこと
//通知内容編集後のバックエンドへのPOSTの実装(PressCreateの実装)
//上記POSTのURLの決定
<template>
  <div>
    <menubar />
    <div class="container">

      <div id="title" class="d-flex justify-content-between">      
        <div class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          <p class="h1">通知新規作成</p>
        </div>

      </div>

      <div class="message">
        <!-- 送信先フォームを設定する必要あり -->
        <form @submit.prevent="submit">
          <div class="table_style bottom-border">
            <div class="table_cell_left text-right text-black">
              <label for="message_title_input">タイトル</label>
            </div>
            <div class="table_cell_right">
              <input type="text" maxlength="255" name="title" id="message_title_input" class="input_title" v-model="form.title" required />
            </div>
          </div>

          <div class="table_style bottom-border">
            <div class="table_cell_left text-right text-black">通知予約</div>
            <div class="table_cell_right">
              <input type="radio" value="1" name="scheduled_at" id="making" class="visually-hidden" v-model="form.is_draft" required />
              <label class="custom-input-label" for="making">作成中</label>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <input type="radio" value="0" name="scheduled_at" id="reserve" class="visually-hidden" v-model="form.is_draft" required />
              <label class="custom-input-label" for="reserve">予約する</label>
              <!-- <input class="reserve_time_input" type="datetime-local" name="" id="" v-model="form.scheduled_at"/> -->
              <input type="date" min="2000-01-01" max="2035-12-31" id="scheduled_at" class="client-input-date input__date" v-model="form.scheduled_at_date" v-on:change="concat_date_and_time" required/>
              <input type="time" id="" class="input__time" v-model="form.scheduled_at_time" v-on:change="concat_date_and_time" required/>

            </div>
          </div>

          <div class="table_style bottom-border">
            <div class="table_cell_left text-right text-black">重要アイコン</div>
            <div class="table_cell_right">
              <input type="radio" value="0" name="is_important" class="visually-hidden" id="is_not_important" v-model="form.is_important" required />
              <label class="custom-input-label" for="is_not_important">表示しない</label>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <input type="radio" value="1" name="is_important" class="visually-hidden" id="is_important" v-model="form.is_important" />
              <label class="custom-input-label" for="is_important">表示する</label>
            </div>
          </div>
          
          <!-- <div class="table_style bottom-border">
            <div class="table_cell_left text-right text-black">下書きアイコン</div>
            <div class="table_cell_right">
              <input type="radio" value="0" name="is_draft" class="visually-hidden" id="is_not_draft" v-model="form.is_draft" required />
              <label class="custom-input-label" for="is_not_draft">表示しない</label>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <input type="radio" value="1" name="is_draft" class="visually-hidden" id="is_draft" v-model="form.is_draft" />
              <label class="custom-input-label" for="is_draft">表示する</label>
            </div>
          </div> -->

          <div class="table_style bottom-border">
            <div class="table_cell_left text-right text-black">
              <label for="message_content_textarea">内容</label>
            </div>
            <div class="table_cell_right">
              <textarea name="" id="message_content_textarea" cols="30" rows="10" v-model="form.text" required></textarea>
            </div>
          </div>
          <div class="table_style modal-btn d-flex justify-content-evenly">
            <input type="button" class="btn btn-red btn-cans" value="キャンセル" @click="redirectIndex" />
            <input type="submit" class="btn btn-purple btn-add" value="作成"/>
          </div>
        </form>
      </div>
   
   
   </div>
    <footerComponent />
  </div>
</template>

<script>
import { defineComponent, reactive } from 'vue';
import { Inertia } from '@inertiajs/inertia'
import modal from '@/Pages/Components/modal.vue';
import footerComponent from "@/Pages/Components/footer.vue";
import menubar from '@/Pages/JVTA/menu_jvta.vue';

export default defineComponent({
  setup () {
    const form = reactive({
      title: null,
      text: null,
      is_important: null,
      is_draft: null,
      scheduled_at: null,
      scheduled_at_date: null,
      scheduled_at_time: null,
    })

    function submit() {
      Inertia.post('/messages', form)
    }

    return { form, submit }
  },
  components: {
    menubar,
    modal,
    footerComponent,
  },
  methods: {
    insertNowTime: function () {
      const now = new Date();
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
      let nowTime = now.toISOString('yyyy-MM-ddThh:mm').slice(0, -1);
      nowTime = nowTime.slice(0, -6) + '00.000';
      this.form.scheduled_at_date = nowTime.split('T')[0];
      this.form.scheduled_at_time = nowTime.split('T')[1];
      this.form.scheduled_at = this.form.scheduled_at_date + 'T' + this.form.scheduled_at_time;
    },
    concat_date_and_time:function () {
      this.form.scheduled_at = this.form.scheduled_at_date + 'T' + this.form.scheduled_at_time;
    },
    change_is_draft: function (event) {
      if (event.target.value == 'making'){
        this.form.is_draft = 1;
      }
    },
    redirectIndex: function () {
      location.href = route('messages.index');
    },
  },
  beforeMount() {
    this.insertNowTime();
  },

});
</script>

<style lang="scss" scoped>
// タイトル部分「用語集一覧」のcss
.container {
  #title {
    margin: 3rem 0;
    img {
      width: 3rem;
      height: 3rem;
    }
    p {
      color: #333333;
    }
  }
  .title-btn {
    margin: 3rem 0;
    #title {
      margin: 0;
      img {
        width: 3rem;
        height: 3rem;
      }
      p {
        color: #666666;
      }
    }
  }
}

.message {
  width: 100%;
  margin: auto;
  border: 1px solid #b1b0b0;
  border-radius: 10px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 13px;
  color: #666666;
  background-color: #ffffff;
  /* font-weight: normal; */
  /*　（全角+半角）の文字で改行しないように */
  white-space: nowrap;
}
.table_style {
  width: 100%;
  padding: 15px 0px;
  display: table;
}
.table_cell_left {
  border-right: 1px solid #b1b0b0;
  display: table-cell;
  vertical-align: middle;
  padding-right: 1rem;
  font-size:1rem;
}
.table_cell_right {
  display: table-cell;
  vertical-align: middle;
  padding-left: 1rem;
  font-size:1rem;
}
.text-right {
  width: 115px;
  text-align: right;
}
.text-left {
  width: 0px;
  text-align: left;
}
.left-padding {
  padding-left: 15px;
}
.bottom-border {
  border-bottom: 1px solid #b1b0b0;
}
.username {
  padding-top: 10px;
  height: 40px;
}

#title {
  margin: 3rem 0;
}
#title img {
  width: 3rem;
  height: 3rem;
}
#title p {
  color: #666666;
}

.container {
  min-height: 80vh;
}
.table {
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

#message_title_input,
#message_content_textarea {
  width: 100%;
  border: 1px solid #b1b0b0;
  border-radius: 5px;
}

.reserve_time_input {
  margin-left: 3rem;
}
.btn-and-btn {
  text-align: center;
}

.custom-input-label {
  position: relative;
  cursor: pointer;
  padding-left: 30px;
  min-width: 100px;
}
.custom-input-label::before,
.custom-input-label::after {
  content: '';
  display: block;
  border-radius: 50%;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
}
.custom-input-label::before {
  background-color: #fff;
  border: 1.5px solid #ddd;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  left: 5px;
}
.custom-input-label::after {
  background-color: rgb(0, 0, 0);
  border-radius: 50%;
  opacity: 0;
  width: 16px;
  height: 16px;
  left: 7px;
}
input:checked + .custom-input-label::after {
  opacity: 1;
}

.visually-hidden {
  position: absolute;
  white-space: nowrap;
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
}

.input_title{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}


.input__date{
  position:relative;
  max-width: 8rem;
  background-image: url('/img/calendar_icon.svg');
  background-repeat: no-repeat;
  background-size: 1.25rem;
  background-position: right 0.5rem center;
  // padding: 0.25rem 2rem 0.2rem 0.5rem;
  // height: 2.5rem;
}
.input__date::-webkit-calendar-picker-indicator {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.client-input-date{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  width: 10rem;
  border: 1px solid #b1b0b0;
  border-radius: 5px;
  color : #b1b0b0;
  margin-left: 1.5rem;
}

.input__time{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  width: 3.5rem;
  text-align: center;
  border: 1px solid #b1b0b0;
  border-radius: 5px;
  margin-left:2rem;
  color : #b1b0b0;


}
.input__time::-webkit-calendar-picker-indicator {
  display: none;
  color : #b1b0b0;
}
</style>
